import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function LoginPage() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/leads" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/leads");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(
        typeof detail === "string"
          ? detail
          : "Anmeldung fehlgeschlagen"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#F8F9FA]"
      data-testid="login-page"
    >
      <div className="w-full max-w-[400px] px-6">
        <div className="mb-10 text-center">
          <h1 className="text-2xl font-bold tracking-tight text-[#0A4F53]">
            ImmoBiber
          </h1>
          <p className="text-sm text-[#5E646A] mt-1 font-medium">Lead Engine</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-lg border border-[#E2E4E9] p-8 shadow-sm"
          data-testid="login-form"
        >
          <div className="space-y-5">
            <div>
              <Label
                htmlFor="email"
                className="text-xs font-semibold text-[#5E646A] uppercase tracking-wider mb-1.5 block"
              >
                E-Mail
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="name@immobiber.de"
                data-testid="login-email-input"
                autoFocus
                required
              />
            </div>
            <div>
              <Label
                htmlFor="password"
                className="text-xs font-semibold text-[#5E646A] uppercase tracking-wider mb-1.5 block"
              >
                Passwort
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Passwort eingeben"
                data-testid="login-password-input"
                required
              />
            </div>

            {error && (
              <p
                className="text-sm text-red-600 bg-red-50 rounded px-3 py-2"
                data-testid="login-error"
              >
                {error}
              </p>
            )}

            <Button
              type="submit"
              className="w-full bg-[#0A4F53] hover:bg-[#073B3E] text-white font-medium"
              disabled={submitting}
              data-testid="login-submit-button"
            >
              {submitting ? "Anmelden..." : "Anmelden"}
            </Button>
          </div>
        </form>

        <p className="text-center text-xs text-[#8A9198] mt-6">
          ImmoBiber Lead Engine - MVP
        </p>
      </div>
    </div>
  );
}
